module.exports = __webpack_public_path__ + "img/abundant3.fe80488a.png";